@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.destination-address-modal-body {
  width: 600px;
  max-height: 600px;
  padding: 15px;
  background-color: @ship-together-destination-modal--body--background-color;
}

.modal-footer {
  display: flex;
  justify-content: space-between;

  button:last-child {
    margin-left: 10px;
  }

  .total-item-qty {
    margin-left: 65px;
    font-weight: 500;
    font-size: 14px;

    .item-num {
      margin-left: 5px;
    }
  }
}

.destination-address-header {
  background-color: @ship-together-destination-modal--destination-address-header--background-color;
  color: @ship-together-destination-modal--destination-address-header--text-color;

  .icon-wrapper {
    padding-left: @space-4;
    color: @ship-together-destination-modal--destination-address-header--fill-color;
  }
}

.address-selector-list {
  display: flex;
  flex-direction: column;
}

.shipment-selector.selected-shipment {
  border: 1px solid @ship-together-destination-modal--selected-shipment--border-color;
}

.shipment-selector {
  display: flex;
  align-items: center;
  padding-left: 10px;
  margin-bottom: 10px;
  border: 1px solid @ship-together-destination-modal--shipment-selector--border-color;
  background-color: @ship-together-destination-modal--shipment-selector--background-color;
  cursor: pointer;

  &:hover {
    background-color: @ship-together-destination-modal--shipment-selector--hover--background-color;
  }
}

.shipment-selector-radio {
  margin-bottom: 0;
}

.shipment-selector-section {
  text-align: left;
  padding: 10px;
  border-left: 1px solid @ship-together-destination-modal--shipment-selector-section--border-color;
  background-color: @ship-together-destination-modal--shipment-selector-section--background-color;
  width: 100%;

  &:hover {
    background-color: @ship-together-destination-modal--shipment-selector-section--hover--background-color;
  }
}

.loading-indicator {
  padding: 0 10px;
  height: 40px;
  margin: auto;
}

.loading-indicator-wrapper {
  height: 100%;
  width: 100%;
  min-height: 300px;
  display: flex;
}

.address-sections {
  display: flex;
  margin-top: 10px;
  border-top: 1px solid @ship-together-destination-modal--address-sections--border-color;
  padding-top: 10px;
}

.address-info {
  font-size: 14px;
  width: 100%;
  padding-top: 10px;

  > button {
    margin-top: 4px;
  }
}

.shipment-sections {
  display: flex;
  margin-top: 10px;
}

.shipment-labels {
  font-size: 14px;
  font-weight: 500;
  min-width: 140px;
  padding-right: 20px;
  text-align: right;
  padding-top: 10px;
}

.shipment-info {
  font-size: 14px;
  width: 100%;
  padding-top: 10px;
  border-top: 1px solid @ship-together-destination-modal--shipment-info--border-color;
}

.selected-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 500;

  .selected-order-number {
    display: flex;
    align-items: center;
  }
}

.other-headers {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  align-items: center;

  .other-order-numbers {
    font-weight: 500;
    align-items: center;
    display: flex;
  }

  .num-of-items {
    margin-right: 4px;
    font-weight: 500;
  }
}

.store-logos {
  > img {
    height: 16px;
    width: 16px;
    margin-right: 6px;
  }
}

.amzWarning {
  background-color: @ship-together-destination-modal--amazon-warning--background-color;
  padding: 16px 16px 28px;
  width: 500px;
  display: flex;
  border-radius: 4px;
  align-items: center;
  font-size: 12.5px;
  cursor: pointer;
  margin: 16px 16px 0;
}

.amzWarningIcon {
  width: 36px;
  padding-right: 8px;
  display: flex;
  align-items: center;

  > svg {
    fill: @ship-together-destination-modal--amazon-warning-icon--fill;
  }
}

.verticalLine {
  border-left: 2px solid @ship-together-destination-modal--amazon-warning-vertial-line--color;
  height: 40px;
  padding-right: 8px;
}

.amzHref {
  position: absolute;
  left: 58px;
  margin-top: 58px;
}

.error-modal {
  width: 420px;
}

.combine-button-content {
  display: flex;
}

.combine-button-text {
  flex: 0;
}

.combine-button-loading-indicator {
  flex: 0;
  padding: @space-0 @space-16;
  height: 30px;
  margin: auto;
}
